import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../lib/api";
import { fmtDate } from "../../lib/dateUtil";
import { SUB_JOB_STATUS } from "./SubJobProgress";
import { ArrowElbowDownRight } from "@phosphor-icons/react";

/* Sub-job rows rendered directly under an expanded main-job row in the Jobs table */
export default function SubJobsExpandRows({ parentId, colSpan }) {
  const [rows, setRows] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    API.get(`/jobs/${parentId}/sub-jobs`).then(({ data }) => setRows(data.sub_jobs || [])).catch(() => setRows([]));
  }, [parentId]);

  if (rows === null) return <tr data-testid={`sub-jobs-loading-${parentId}`}><td colSpan={colSpan} className="px-3 py-2 text-[11px] text-muted-foreground bg-violet-50/40 dark:bg-violet-950/10">Loading sub-jobs…</td></tr>;
  if (rows.length === 0) return <tr><td colSpan={colSpan} className="px-3 py-2 text-[11px] text-muted-foreground bg-violet-50/40 dark:bg-violet-950/10">No sub-jobs yet.</td></tr>;
  return rows.map((c) => {
    const st = SUB_JOB_STATUS[c.status] || SUB_JOB_STATUS.scheduled;
    return (
      <tr key={c.id} className="bg-violet-50/40 dark:bg-violet-950/10 hover:bg-violet-100/50 dark:hover:bg-violet-900/20 cursor-pointer" onClick={() => navigate(`/jobs/${c.id}`)} data-testid={`sub-job-list-row-${c.id}`}>
        <td colSpan={colSpan - 1} className="px-3 py-2">
          <div className="flex items-center gap-2 pl-6">
            <ArrowElbowDownRight size={12} className="text-violet-500 shrink-0" />
            <span className="h-5 w-5 rounded-full bg-violet-100 dark:bg-violet-900/40 text-violet-800 dark:text-violet-200 text-[10px] font-bold flex items-center justify-center shrink-0">{c.sub_job_index}</span>
            <span className="text-[11px] font-mono font-semibold text-primary">{c.reference}</span>
            <span className="text-xs truncate max-w-[260px]">{c.title}</span>
            <span className="text-[10px] text-muted-foreground hidden md:inline">{c.assigned_operative_name || c.assigned_vendor_name || "Unassigned"}</span>
            <span className="text-[10px] text-muted-foreground hidden md:inline">{c.schedule?.start_date ? fmtDate(c.schedule.start_date) : "Not scheduled"}</span>
          </div>
        </td>
        <td className="px-3 py-2 text-right"><span className={`text-[10px] px-2.5 py-1 rounded-full font-medium inline-block ${st.color}`}>{st.label}</span></td>
      </tr>
    );
  });
}
